import React from "react";
import useCurrentUser from "hooks/useCurrentUser";

const withActiveOrg = (Wrapped) => (props) => {
  const { activeOrg, activeOrgId } = useCurrentUser();
  return <Wrapped {...props} activeOrg={activeOrg} activeOrgId={activeOrgId} />;
};

export default withActiveOrg;
